import { QrRecept } from "@/feature/phr-28/components/template/QrRecept/ QrRecept"

export const QR: React.FC = () => {
    return (
        <QrRecept />
    )
}
